import { graphql, useStaticQuery } from "gatsby";

type SiteSettingsModel = {
    name: string;
    legalName: string;
    baseUrl: string;
    logo: {
        src: string;
        alt: string
        width: number;
        height: number;
    };
    description: string;
    phone: string;
    email: string;
    image: string;
    foundingDate: number;
    founders: Array<{
        name: string;
        occupation: string;
        socialLink: string;
    }>
    businessAddress: {
        street: string;
        city: string;
        state: string;
        zip: string;
    };
    rating: {
        value: string;
        outOf: string;
        reviews: string;
    };
    socialLinks: string;
    gtmId: string;
    fbAppId: string;
    twitterAuthor: string;
};

export const useSiteSettings = () => {
    const { site } = useStaticQuery<{
        site: SiteSettingsModel
    }>(siteSettingsQuery);

    return site;
};

const siteSettingsQuery = graphql`
    query {
        site: siteJson {
            name
            legalName
            baseUrl
            logo {
                src
                alt
                width
                height
            }
            description
            phone
            email
            image
            foundingDate
            founders {
                name
                occupation
                socialLink
            }
            businessAddress {
                street
                city
                state
                zip
            }
            rating {
                value
                outOf
                reviews
            }
            socialLinks
            gtmId
            fbAppId
            twitterAuthor
        }
    }
`;